import { render, staticRenderFns } from "./LandingBabyRegistryPT.vue?vue&type=template&id=c3a46f20&scoped=true"
import script from "./LandingBabyRegistryPT.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryPT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a46f20",
  null
  
)

export default component.exports